var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SimplePopup',{attrs:{"title":_vm.popupTitle,"message":_vm.popupMessage,"buttonText":'button > continue'},on:{"dismiss":function($event){_vm.popupTitle=null;_vm.popupMessage=null;_vm.$controller.view.editProfile.open();}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }